// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["query AcademyYearLevelMappingsQuery  {\naccountInt  {\n__typename\nyearLevelMapping  {\n__typename  \nyearLevels  {\n__typename  \nlevelInt  \nlevelEnum  \nschoolYear(format: SHORT)  \nlongYear: schoolYear(format: LONG)  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.accountInt;
  var value$2 = value$1.yearLevelMapping;
  var value$3 = value$2.yearLevels;
  return {
          accountInt: {
            yearLevelMapping: {
              __typename: value$2.__typename,
              yearLevels: value$3.map(function (value) {
                    var value$1 = value.levelEnum;
                    var tmp;
                    switch (value$1) {
                      case "LEVEL_0" :
                          tmp = "LEVEL_0";
                          break;
                      case "LEVEL_1" :
                          tmp = "LEVEL_1";
                          break;
                      case "LEVEL_10" :
                          tmp = "LEVEL_10";
                          break;
                      case "LEVEL_11" :
                          tmp = "LEVEL_11";
                          break;
                      case "LEVEL_12" :
                          tmp = "LEVEL_12";
                          break;
                      case "LEVEL_2" :
                          tmp = "LEVEL_2";
                          break;
                      case "LEVEL_3" :
                          tmp = "LEVEL_3";
                          break;
                      case "LEVEL_4" :
                          tmp = "LEVEL_4";
                          break;
                      case "LEVEL_5" :
                          tmp = "LEVEL_5";
                          break;
                      case "LEVEL_6" :
                          tmp = "LEVEL_6";
                          break;
                      case "LEVEL_7" :
                          tmp = "LEVEL_7";
                          break;
                      case "LEVEL_8" :
                          tmp = "LEVEL_8";
                          break;
                      case "LEVEL_9" :
                          tmp = "LEVEL_9";
                          break;
                      case "PRE" :
                          tmp = "PRE";
                          break;
                      case "UNKNOWN" :
                          tmp = "UNKNOWN";
                          break;
                      default:
                        throw {
                              RE_EXN_ID: "Not_found",
                              Error: new Error()
                            };
                    }
                    return {
                            __typename: value.__typename,
                            levelInt: value.levelInt,
                            levelEnum: tmp,
                            schoolYear: value.schoolYear,
                            longYear: value.longYear
                          };
                  })
            }
          }
        };
}

function serialize(value) {
  var value$1 = value.accountInt;
  var value$2 = value$1.yearLevelMapping;
  var value$3 = value$2.yearLevels;
  var yearLevels = value$3.map(function (value) {
        var value$1 = value.longYear;
        var value$2 = value.schoolYear;
        var value$3 = value.levelEnum;
        var levelEnum = value$3 === "LEVEL_10" ? "LEVEL_10" : (
            value$3 === "LEVEL_11" ? "LEVEL_11" : (
                value$3 === "LEVEL_12" ? "LEVEL_12" : (
                    value$3 === "PRE" ? "PRE" : (
                        value$3 === "LEVEL_0" ? "LEVEL_0" : (
                            value$3 === "LEVEL_1" ? "LEVEL_1" : (
                                value$3 === "LEVEL_2" ? "LEVEL_2" : (
                                    value$3 === "LEVEL_3" ? "LEVEL_3" : (
                                        value$3 === "LEVEL_4" ? "LEVEL_4" : (
                                            value$3 === "LEVEL_5" ? "LEVEL_5" : (
                                                value$3 === "LEVEL_6" ? "LEVEL_6" : (
                                                    value$3 === "LEVEL_7" ? "LEVEL_7" : (
                                                        value$3 === "LEVEL_8" ? "LEVEL_8" : (
                                                            value$3 === "LEVEL_9" ? "LEVEL_9" : "UNKNOWN"
                                                          )
                                                      )
                                                  )
                                              )
                                          )
                                      )
                                  )
                              )
                          )
                      )
                  )
              )
          );
        var value$4 = value.levelInt;
        var value$5 = value.__typename;
        return {
                __typename: value$5,
                levelInt: value$4,
                levelEnum: levelEnum,
                schoolYear: value$2,
                longYear: value$1
              };
      });
  var value$4 = value$2.__typename;
  var yearLevelMapping = {
    __typename: value$4,
    yearLevels: yearLevels
  };
  var accountInt = {
    yearLevelMapping: yearLevelMapping
  };
  return {
          accountInt: accountInt
        };
}

function serializeVariables(param) {
  
}

function makeVariables(param) {
  
}

function makeDefaultVariables(param) {
  
}

var AcademyYearLevelMappingsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var AcademyYearLevelMappingsQuery = {
  AcademyYearLevelMappingsQuery_inner: AcademyYearLevelMappingsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  use: use,
  useFetch: useFetch
};

var YLM = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

var levels = [
  [
    "LEVEL_0",
    " - ",
    ""
  ],
  [
    "LEVEL_1",
    "1",
    ""
  ],
  [
    "LEVEL_2",
    "2",
    ""
  ],
  [
    "LEVEL_3",
    "3",
    ""
  ],
  [
    "LEVEL_4",
    "4",
    ""
  ],
  [
    "LEVEL_5",
    "5",
    ""
  ],
  [
    "LEVEL_6",
    "6",
    ""
  ],
  [
    "LEVEL_7",
    "7",
    ""
  ],
  [
    "LEVEL_8",
    "8",
    ""
  ],
  [
    "LEVEL_9",
    "9",
    ""
  ],
  [
    "LEVEL_10",
    "10",
    ""
  ]
];

function handleResponse(res) {
  return {
          loading: false,
          levels: Belt_Array.reduce(res.accountInt.yearLevelMapping.yearLevels, [], (function (levels, yl) {
                  if (yl.levelInt === -1 || yl.levelInt > 10) {
                    return levels;
                  } else {
                    return Belt_Array.concatMany([
                                levels,
                                [[
                                    yl.levelEnum,
                                    yl.schoolYear,
                                    yl.longYear
                                  ]]
                              ]);
                  }
                }))
        };
}

function onResult(query) {
  return Belt_Result.map(query, handleResponse);
}

function onLoading(param) {
  return {
          loading: true,
          levels: levels
        };
}

function use$1(param) {
  return Curry._4(YLM.useWithErrorModal, onLoading, onLoading, onResult, undefined);
}

export {
  AcademyYearLevelMappingsQuery ,
  YLM ,
  levels ,
  handleResponse ,
  onResult ,
  onLoading ,
  use$1 as use,
}
/* query Not a pure module */
